import * as actionTypes from './actionTypes';

export const markAsReadNotification = ( id: number ) => {
  return {
      type: actionTypes.NOTIFICATION_MARK_AS_READ,
      test_id: id
  };
};

export const setNotifications = ( notifications: any ) => {
  return {
      type: actionTypes.NOTIFICATION_INIT,
      notificationData: notifications
  };
};
